import React from 'react'
import "./TabContent.scss"

const TabContent = (props) => {

    const { children,  className } = props


    return (
        <div className={`${className}`}>
            {children}
        </div>
    )
}

export default TabContent